import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIsMobile } from '../../../theme/useIsMobile'
import { useIsMd } from '../../../theme/useIsMd'
import { useIsLg } from '../../../theme/useIsLg'
import { TakeItFromHappyMembersSection } from './TakeItFromHappyMembersSection'
import { useIsXl } from '../../../theme/useIsXl'

export function TakeItFromHappyMembers() {
  const { t } = useTranslation()

  const isMobile = useIsMobile()
  const isMdOrUp = useIsMd()
  const isLgOrUp = useIsLg()
  const isXlOrUp = useIsXl()

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return 1
    }
    if (isXlOrUp) {
      return 5
    }
    if (isLgOrUp) {
      return 4
    }
    if (isMdOrUp) {
      return 3
    }
    return 2
  }, [isMobile, isLgOrUp, isMdOrUp])

  const quotes = [
    {
      quote: t('takeItFromHappyMembers.quotes.0.quote'),
      name: t('takeItFromHappyMembers.quotes.0.name'),
      title: t('takeItFromHappyMembers.quotes.0.title'),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.1.quote'),
      name: t('takeItFromHappyMembers.quotes.1.name'),
      title: t('takeItFromHappyMembers.quotes.1.title'),
      organization: t('takeItFromHappyMembers.quotes.1.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/searcy-financial.png"
          alt="Searcy Financial logo"
        />
      ),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.2.quote'),
      name: t('takeItFromHappyMembers.quotes.2.name'),
      title: t('takeItFromHappyMembers.quotes.2.title'),
      organization: t('takeItFromHappyMembers.quotes.2.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/tcb.png"
          alt="TCB logo"
        />
      ),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.3.quote'),
      name: t('takeItFromHappyMembers.quotes.3.name'),
      title: t('takeItFromHappyMembers.quotes.3.title'),
      organization: t('takeItFromHappyMembers.quotes.3.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/arete-wealth.png"
          alt="Arete Wealth logo"
        />
      ),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.4.quote'),
      name: t('takeItFromHappyMembers.quotes.4.name'),
      title: t('takeItFromHappyMembers.quotes.4.title'),
      subtitle: t('takeItFromHappyMembers.quotes.4.subtitle'),
      organization: t('takeItFromHappyMembers.quotes.4.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/nationwide.png"
          alt="Nationwide logo"
        />
      ),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.5.quote'),
      name: t('takeItFromHappyMembers.quotes.5.name'),
      title: t('takeItFromHappyMembers.quotes.5.title'),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.6.quote'),
      name: t('takeItFromHappyMembers.quotes.6.name'),
      title: t('takeItFromHappyMembers.quotes.6.title'),
      organization: t('takeItFromHappyMembers.quotes.6.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/cn.png"
          alt="CN logo"
        />
      ),
    },
    {
      quote: t('takeItFromHappyMembers.quotes.7.quote'),
      name: t('takeItFromHappyMembers.quotes.7.name'),
      organization: t('takeItFromHappyMembers.quotes.7.organization'),
      logo: (
        <StaticImage
          height={60}
          src="../../../../static/images/banklogos/mass-mutual.png"
          alt="Mass Mutual logo"
        />
      ),
    },
  ]

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 3500,
    cssEase: 'linear',
    accessibility: false,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow,
    slidesToScroll: 1,
  }

  return (
    <TakeItFromHappyMembersSection
      carouselSettings={carouselSettings}
      quotes={quotes}
    />
  )
}
